console.info("当前环境!")
console.info(process.env.NODE_ENV)

const apis={
    login: `/login`,//登录
    loginOut: `/loginouter/{token}`, //退出登录
    code: `/code/{name}`, //发送验证码
    checkCode: `/check_code`, //校验验证码
    editPwd: `/userpwd`, //修改密码
    verification: `/verification/{name}`, //弹出验证码
    getCode: `/getcode`, //获取滑动图片
    sys: `/systeminfo`,//选择平台
    qycode: `/login`,//企业微信code
    codewx: `/codeWx`,//发送企业微信code
    haseToken: `/queryuserbytoken`,
    codeImage:`/code_img`,
    loginEmial:`/loginEmail`
}

export default apis;



// WEBPACK FOOTER //
// ./src/apiConfig/api_config.js